import axios from "axios"

import { API_URL } from "../../config/appConfig"

export const DAILYLIST_URL = `${API_URL}/api/DailyList`

export const getDailyListApproval = () => {
  return axios.get(`${DAILYLIST_URL}/approval`)
}

export const getDailyListUnApproved = () => {
  return axios.get(`${DAILYLIST_URL}/notApproved`)
}

export const getDailyListExcluded = () => {
  return axios.get(`${DAILYLIST_URL}/excluded`)
}

export const getIsDLPosted = () => {
  return axios.get(`${DAILYLIST_URL}/isPosted`);
}

export const getDLStats = () => {
  return axios.get(`${DAILYLIST_URL}/stats`);
}

export const getSingleDailyListEntry = (symbol: string) => {
  return axios.get(`${DAILYLIST_URL}/getEntry/${symbol}`)
}

export const getPostedDailyList = (advanced: boolean, headers : any) => {
  return axios.get(`${DAILYLIST_URL}/posted/${advanced}`, {headers})
}

export const putDailyList = (nsm: string, dlEntryComment: string, systemNoteComment: string) => {
  return axios.put(`${DAILYLIST_URL}?nsm=${nsm}&dlEntryComment=${dlEntryComment}&systemNoteComment=${systemNoteComment}`)
}

export const postDailyList = (nsm: string, dlEntryComment: string, systemNoteComment: string) => {
  return axios.post(`${DAILYLIST_URL}?nsm=${nsm}&dlEntryComment=${dlEntryComment}&systemNoteComment=${systemNoteComment}`)
}

export const excludeDailyList = (nsm: string) => {
  return axios.put(`${DAILYLIST_URL}/dailyListExclude?nsm=${nsm}`)
}

export const includeDailyList = (nsm: string) => {
  return axios.put(`${DAILYLIST_URL}/dailyListInclude?nsm=${nsm}`)
}

export const postGlobalDailyList = (systemNote: string) => {
  return axios.post(`${DAILYLIST_URL}/postGlobalDailyList?systemNote=${systemNote}`)
}

export const getIsDailyListPosted = () => {
  return axios.get(`${DAILYLIST_URL}/isPosted`)
}

export const postSearchDailyList = ({ advanced, ...payload }: any, headers: any, params : any) => {
  return axios.post(
    `${DAILYLIST_URL}/search/${advanced}`, payload,{headers, params}
    )
}

export const getInstrumentDocumentPaginatedData = (pageIndex: number, pageSize: number, payload: any, params: any, headers: any) => {
  return axios.post(`${DAILYLIST_URL}/instrumentDocuments/${pageIndex}/${pageSize}`, payload, { params, headers })
}

export const getDailyListDocuments = (isAdvanced : boolean, headers : any) => {
  return axios.get(`${DAILYLIST_URL}/dailyListDocuments/${isAdvanced}`, {headers})
}

export const getInstrumentsPendingApprovalCount = () => {
  return axios.get(`${DAILYLIST_URL}/exceptionCount`)
}

export const getInstrumentsPendingApproval = () => {
  return axios.get(`${DAILYLIST_URL}/exceptions`)
}